<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-admin-cosmetic-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>
